import React from "react";
import Button from "@shared/v2/Button";
import TextButton from "@shared/v2/TextButton";
import { ArrowUpRightFromSquareSolidV6 } from "@shared/v2/Icomoon";
import ZoomCard from "./shared/ZoomCard";

const BrivityVaCard = () => (
  <ZoomCard
    actions={
      <>
        <Button
          size="medium"
          schema="secondary"
          className="tw-flex tw-items-center tw-gap-[4px]"
          onClick={() => {}}
        >
          Interview VA <ArrowUpRightFromSquareSolidV6 />
        </Button>
        <TextButton className="tw-px-0 tw-flex tw-items-center tw-gap-[4px]" size="medium">
          Learn More <ArrowUpRightFromSquareSolidV6 />
        </TextButton>
      </>
    }
    title="Brivity VA"
    description="Our virtual real estate assistants give you the time you deserve to focus on what you do best while keeping productivity up and costs down."
    imgSrc="/images/bg-card-brivity-va.png"
    imgClassName="tw-mr-[-12px]"
  />
);

export default BrivityVaCard;
